import { Component } from 'react';
import { Box, Button, Drawer, Stack, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from
    "../../../../Components/Common Components/CommonComponents";
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { DateTime } from 'luxon';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';

class IMARegistration extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            imaRegistrationData: [],
            isLoader: false,
            printLoad: false
        }
    }

    componentDidMount() {
        this.getIMARegistrationData()
    }

    getIMARegistrationData = () => {
        try {
            this.setState({ isLoader: true })
            RestAPIService.getAll(Serviceurls.FO_IMA_REGISTRATION +
                '?from_date=' + this.state.fromDate +
                '&to_date=' + this.state.toDate)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            imaRegistrationData: response?.data?.data,
                            isLoader: false
                        })
                    }
                }).catch(error => {
                    this.setState({ isLoader: false })
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ isLoader: false })
            this.errorMessage(error.message)
        }
    }

    getIMARegistrationPrint = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_IMA_REGISTRATION +
                '?from_date=' + this.state.fromDate +
                '&to_date=' + this.state.toDate +
                '&export_type=pdf'
            ).then((response) => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.setState({ printLoad: false })
            }).catch((error) => {
                this.setState({ printLoad: false })
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
        } catch (error) {
            this.setState({ printLoad: false })
            this.errorMessage(error.message)
        }
    }

    getIMARegistrationExcel = () => {
        try {
            RestAPIService.excelGet(Serviceurls.FO_IMA_REGISTRATION +
                '?from_date=' + this.state.fromDate +
                '&to_date=' + this.state.toDate +
                '&export_type=excel'
            ).then((response) => {
                if (response.data) {
                    var pom = document.createElement('a');
                    var csvContent = response.data; //here we load our csv data 

                    let filename = response.headers["content-disposition"].split("filename=")[1]

                    var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                    var url = URL.createObjectURL(blob);
                    pom.href = url;
                    pom.setAttribute('download', filename ? filename : 'ima.xlsx');
                    pom.click();
                    this.setState({ printLoad: false })
                }
            }).catch((error) => {
                this.setState({ printLoad: false })
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
        } catch (error) {
            this.setState({ printLoad: false })
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            }, () => this.getIMARegistrationData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            this.setState({ FilterOpen: false }, () => this.getIMARegistrationData())
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box><CommonGridToolBarWithFilterText FilterTextArray={TextArray} /></Box>
        )
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    render() {
        this.state.imaRegistrationData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("PatientName"), flex: 0.2,
                renderCell: (params) => (<CommonPatientDetails data={params?.row} />), valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.mobile_no || "";
                    const UHID = params.row?.uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: "pov", headerName: t("Purpose Of Visit"), flex: 0.2, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.pov ? params?.row?.pov?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.pov} arrow><div>{params?.row?.pov.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.pov : "-"}</Box>)
            },
            {
                field: "investigation", headerName: t("Investigation"), flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.investigation ? params?.row?.investigation?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.investigation} arrow><div>{params?.row?.investigation.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.investigation : "-"}</Box>)
            },
            {
                field: "final_diagnosis", headerName: t("Final Diagnosis"), flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.final_diagnosis ? params?.row?.final_diagnosis?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.final_diagnosis} arrow><div>{params?.row?.final_diagnosis.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.final_diagnosis : '-'}</Box>)
            },
            {
                field: "treatment_plan", headerName: t("Treatment Plan"), flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.treatment_plan ? params?.row?.treatment_plan?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.treatment_plan} arrow><div>{params?.row?.treatment_plan.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.treatment_plan : "-"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' disabled={this.state.printLoad}
                            onClick={() => { this.setState({ printLoad: true }, () => this.getIMARegistrationPrint()) }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                        <Button className='eMed_usrconf_btn' disabled={this.state.printLoad}
                            onClick={() => this.setState({ printLoad: true }, this.getIMARegistrationExcel())}
                        >
                            <img src={ImagePaths.LabUploadButton} alt="upload" className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.imaRegistrationData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        pageSizeOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableRowSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}

export default withTranslation()(IMARegistration)